export default {
  appkey: '9108ff6299c082af29833d31f04817b0', // 请输入自己的appkey
  appSecret: '064983b9548b' // 请输入自己的appSecret
}
